<template>
  <span class="brand-lockup">
    <img
      class="brand-mark"
      src="/brand/yawhub.png"
      alt=""
      width="301"
      height="301"
    />
    <span class="brand-wordmark">yawhub<span class="brand-dot">.</span></span>
  </span>
</template>
